import React from 'react';
import { Users, Target, History, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
const timelineData = [{
  year: '2023',
  key: '2023'
}, {
  year: '2024',
  key: '2024'
}, {
  year: '2026',
  key: '2026'
}, {
  year: '2030',
  key: '2030'
}];
const leadershipData = {
  en: [{
    name: 'Irvannanda',
    role: 'Commissioner',
    domain: 'Strategic Oversight'
  }, {
    name: 'Nurfadlan A',
    role: 'Chief Executive Officer',
    domain: 'Executive Leadership'
  }, {
    name: 'N Reza',
    role: 'Chief Operating Officer',
    domain: 'Operations'
  }],
  id: [{
    name: 'Irvannanda',
    role: 'Komisaris',
    domain: 'Pengawasan Strategis'
  }, {
    name: 'Nurfadlan A',
    role: 'Chief Executive Officer',
    domain: 'Kepemimpinan Eksekutif'
  }, {
    name: 'N Reza',
    role: 'Chief Operating Officer',
    domain: 'Operasional'
  }]
};
export function About() {
  const {
    t,
    language
  } = useLanguage();
  const seoTitles = {
    en: 'About NEW ASIA TECH - TECHNOLOGY BEYOND CONTROL. | Leadership & Vision',
    id: 'Tentang NEW ASIA TECH - TEKNOLOGI MELAMPAUI KENDALI. | Kepemimpinan & Visi'
  };
  const seoDescriptions = {
    en: 'Learn about NEW ASIA TECH, a strategic technology institution focused on sovereign intelligence systems. Post-startup paradigm, Global South focus, and cyber-physical reality. Based in Pekanbaru, Indonesia.',
    id: 'Pelajari tentang NEW ASIA TECH, institusi teknologi strategis yang fokus pada sistem intelijen berdaulat. Paradigma pasca-startup, fokus Global South, dan realitas cyber-fisik. Berbasis di Pekanbaru, Indonesia.'
  };
  const currentLeadership = leadershipData[language];
  return <>
      <SEO title={seoTitles[language]} description={seoDescriptions[language]} url="/about" type="website" data-id="element-187" />

      <div className="min-h-screen pt-32 pb-20 px-6" data-id="element-188">
        <div className="max-w-[1800px] mx-auto" data-id="element-189">
          <header className="mb-24 animate-fade-in-up" data-id="element-190">
            <h1 className="text-6xl md:text-8xl font-display font-bold text-ivory tracking-tighter mb-8" data-id="element-191">
              {t('about.title')}
            </h1>
            <div className="h-px w-full bg-gradient-to-r from-muted-gold/50 to-transparent" data-id="element-192" />
          </header>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-32" data-id="element-193">
            <div className="lg:col-span-4 animate-fade-in-up delay-100" data-id="element-194">
              <h2 className="text-xs font-mono text-muted-gold uppercase tracking-widest mb-4 flex items-center" data-id="element-195">
                <Target className="w-4 h-4 mr-2" data-id="element-196" />
                {t('about.who')}
              </h2>
              <p className="text-xl text-ivory font-light leading-relaxed text-balance" data-id="element-197">
                {t('about.who.desc')}
              </p>
            </div>

            <div className="lg:col-span-8 space-y-12 animate-fade-in-up delay-200" data-id="element-198">
              <div data-id="element-199">
                <h3 className="text-3xl font-display font-bold text-ivory mb-6" data-id="element-200">
                  {t('about.paradigm')}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed max-w-3xl" data-id="element-201">
                  {t('about.paradigm.desc')}
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 pt-12 border-t border-white/10" data-id="element-202">
                <div className="group" data-id="element-203">
                  <h4 className="text-xl font-display font-bold text-ivory mb-4 group-hover:text-ai-teal transition-colors" data-id="element-204">
                    {t('about.focus')}
                  </h4>
                  <p className="text-gray-400" data-id="element-205">{t('about.focus.desc')}</p>
                </div>
                <div className="group" data-id="element-206">
                  <h4 className="text-xl font-display font-bold text-ivory mb-4 group-hover:text-ai-teal transition-colors" data-id="element-207">
                    {t('about.cyber')}
                  </h4>
                  <p className="text-gray-400" data-id="element-208">{t('about.cyber.desc')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-32 animate-fade-in-up delay-300" data-id="element-209">
            <h2 className="text-3xl font-display font-bold text-ivory mb-12 flex items-center" data-id="element-210">
              <History className="w-6 h-6 mr-4 text-muted-gold" data-id="element-211" />
              {t('about.roadmap')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative" data-id="element-212">
              <div className="absolute top-8 left-0 w-full h-px bg-white/10 hidden md:block" data-id="element-213" />
              {timelineData.map((item, idx) => <div key={idx} className="relative pt-16 group" data-id="element-214">
                  <div className="absolute top-6 left-0 md:left-1/2 md:-translate-x-1/2 w-4 h-4 bg-carbon border-2 border-muted-gold rounded-full z-10 group-hover:bg-muted-gold transition-colors duration-300 shadow-[0_0_10px_rgba(191,168,106,0.3)]" data-id="element-215" />
                  <div className="text-4xl font-display font-bold text-white/10 mb-2 group-hover:text-white/30 transition-colors" data-id="element-216">
                    {item.year}
                  </div>
                  <h3 className="text-xl font-bold text-ivory mb-2" data-id="element-217">
                    {t(`about.timeline.${item.key}`)}
                  </h3>
                  <p className="text-sm text-gray-400" data-id="element-218">
                    {t(`about.timeline.${item.key}.desc`)}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="mb-32 animate-fade-in-up delay-400" data-id="element-219">
            <h2 className="text-3xl font-display font-bold text-ivory mb-12 flex items-center" data-id="element-220">
              <Users className="w-6 h-6 mr-4 text-ai-teal" data-id="element-221" />
              {language === 'en' ? 'Leadership Council' : 'Dewan Kepemimpinan'}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10" data-id="element-222">
              {currentLeadership.map((person, idx) => <div key={idx} className="bg-carbon p-8 hover:bg-white/5 transition-colors duration-300 group" data-id="element-223">
                  <div className="w-16 h-16 bg-white/5 rounded-full mb-6 flex items-center justify-center group-hover:bg-ai-teal/10 transition-colors" data-id="element-224">
                    <Award className="w-8 h-8 text-gray-500 group-hover:text-ai-teal transition-colors" data-id="element-225" />
                  </div>
                  <h3 className="text-xl font-bold text-ivory mb-1" data-id="element-226">
                    {person.name}
                  </h3>
                  <div className="text-sm text-muted-gold mb-4 uppercase tracking-wider" data-id="element-227">
                    {person.role}
                  </div>
                  <div className="text-xs font-mono text-gray-500 border-t border-white/10 pt-4" data-id="element-228">
                    {language === 'en' ? 'DOMAIN' : 'DOMAIN'}: {person.domain}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="mt-32 animate-fade-in-up delay-500" data-id="element-229">
            <div className="w-full h-[500px] bg-neural-green/10 border border-white/5 relative overflow-hidden flex items-center justify-center group" data-id="element-230">
              <div className="absolute inset-0 bg-tech-grid opacity-30" data-id="element-231" />
              <div className="absolute inset-0 bg-gradient-to-t from-carbon via-transparent to-transparent" data-id="element-232" />
              <div className="text-center relative z-10 transform group-hover:scale-105 transition-transform duration-700" data-id="element-233">
                <div className="text-6xl md:text-9xl font-display font-bold text-white/5 tracking-widest group-hover:text-white/10 transition-colors" data-id="element-234">
                  2030
                </div>
                <div className="text-sm font-mono text-muted-gold mt-4 uppercase tracking-widest animate-pulse-slow" data-id="element-235">
                  {t('about.vision')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}